import React from 'react'
import { Textarea } from './Input'

interface Props {
  value: string
  setValue: (value: string) => void
  placeholder?: string
}

const JSONEditor = (props: Props) => {

  // editor event handlers
  const handleEditorKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (typeof props.value !== 'string' && !props.value) return;
    // prevent tab escape
    if (e.key === 'Tab') {
      e.preventDefault();
      const inputElement = (document.getElementById('json-editor-input') as HTMLTextAreaElement);
      const cursorPosition = inputElement.selectionStart;
      if (cursorPosition === null) return;
      const value = inputElement.value;
      const newValue = value.slice(0, cursorPosition) + '\t' + value.slice(cursorPosition);
      props.setValue(newValue);
      setTimeout(() => {
        inputElement?.setSelectionRange(cursorPosition + 1, cursorPosition + 1);
      }, 0);
    }
  }
  const handleEditorTextChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    if (typeof props.value !== 'string' && !props.value) return;
    const currentValue = e.target.value;
    if (currentValue.length < props.value.length) { // is deleting text
      props.setValue(currentValue);
      return;
    }
    const cursorPosition = e.target.selectionStart;
    const newChar = currentValue[cursorPosition - 1];
    if (newChar === '{' || newChar === '[' || newChar === '"') { // is adding {, [, "
      const newValue = currentValue.slice(0, cursorPosition) + (newChar === '{' ? '}' : newChar === '[' ? ']' : '"') + currentValue.slice(cursorPosition);
      props.setValue(newValue);    
      setTimeout(() => {
        (document.getElementById('json-editor-input') as HTMLInputElement)?.setSelectionRange(cursorPosition, cursorPosition);
      }, 0);
    } else {
      props.setValue(currentValue);
    }
  }

  return (
    <Textarea id='json-editor-input' spellCheck={false} placeholder={props.placeholder || ''} extraclass='font-mono overflow-auto' rows={16} wrap='off' textSize='small' autoFocus
      value={props.value} onChange={handleEditorTextChange} onKeyDown={handleEditorKeyDown}
    />
  )
}

export default JSONEditor